/**
 * Функция которая возвращает корректный offsetX в зависимости от направления контента
 * 
 * @param {Event} event - параметры эвента 
 * @param {HTMLElement} element - целевой html элемент
 * @returns 
 */

const getOffsetXByDirection = (event, element) => {
    const isRTL = document.dir === 'rtl';
    const rect = element.getBoundingClientRect();

    let offsetX = event.pageX - rect.left;
    
    if (isRTL) {
        offsetX = rect.width - offsetX;
    }
    
    return offsetX;
}

export default getOffsetXByDirection;
